/** @typedef {new (...args: any[]) => any} Constructor */

/**
 * @template {!Constructor} T
 * @param {T} superClass - The class to extend
 */
export const IntersectionObserverMixin = superClass => class IntersectionObserverMix extends superClass {

	/**
	 * @type {IntersectionObserver}
	 */
	_intersectionObserver;

	/**
	 * @type {IntersectionObserverInit}
	 */
	intersectionObserverOptions;

	static get properties () {
		return {
			...super.properties,
			intersected: {
				type: Boolean
			}
		};
	}

	connectedCallback () {
		super.connectedCallback();

		/**
		 * @type {boolean}
		 */
		this.intersected = false;

		this._intersectionObserver = new IntersectionObserver(this._intersectionCallback.bind(this), this.intersectionObserverOptions);
		this._intersectionObserver.observe(this);
	}

	/**
	 * Handle the observer callback
	 * @param {IntersectionObserverEntry[]} entries
	 */
	_intersectionCallback ([element]) {
		if (element.isIntersecting) {
			this.intersected = true;

			this.handleIntersection();
			this._intersectionObserver.disconnect();
		}
	}

	handleIntersection () {
		throw new Error('Not implemented.');
	}
};
